import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchPackages = async (params = {}) => {
  const { data } = await api.get("/packages", { params });
  return data;
};

export const fetchPackage = async (slug) => {
  const { data } = await api.get(`/packages/${slug}`);
  return data;
};

export const submitInquiry = async (payload) => {
  const { data } = await api.post("/inquiries", payload);
  return data;
};
